import React, {createRef} from "react";
import Message from "./Message";
import ChatEventCodes from "../utils/ChatEventCodes";

export default class DropdownMessage extends Message {

    constructor(props) {
        super(props);

        this.sendInput = this.sendInput.bind(this);
        this.selectRef = createRef();
        this.selectionErrorRef = createRef();
        this.dropdownOnChange = this.dropdownOnChange.bind(this);
    }

    createDropdownOptions() {
        const dropdownOptionsBlock = [];
        dropdownOptionsBlock.push(<option value=''>Please select</option>);
        for (const element of this.props.payload.elements) {
            dropdownOptionsBlock.push(<option key={element} value={element.value}>{element.title}</option>);
        }
        return dropdownOptionsBlock;
    }

    dropdownOnChange() {
        if (!this.selectRef.current.value || this.selectRef.current.value.trim() === '') {
            this.selectionErrorRef.current.classList.remove('hidden');
        }
        else {
            this.selectionErrorRef.current.classList.add('hidden');
        }
    }


    sendInput() {
        if (!this.selectRef.current.value || this.selectRef.current.value.trim() === '') {
            this.selectionErrorRef.current.classList.remove('hidden');
        }
        else {
            this.selectionErrorRef.current.classList.add('hidden');
            document.dispatchEvent(new MessageEvent(ChatEventCodes.UserClickedInput, {data: this.selectRef.current.value}));
        }
    }

    render() {
        return (
            <div className={this.generateSenderClassName('dropdown')}>
                {this.generateSenderMessage()}
                <div className='dropdown__wrapper message-text'>
                    <div className='dropdown__heading'>
                        {this.props.payload.heading}
                    </div>
                    <div className='dropdown__selection-error hidden' ref={this.selectionErrorRef}>
                        Make a selection
                    </div>
                    <div className='dropdown__input-wrapper'>
                        <select ref={this.selectRef}
                            onChange={this.dropdownOnChange}
                            aria-label='Select your response for the virtual assistant.'>
                            {this.createDropdownOptions()}
                        </select>
                        <button className='dropdown__send button--black' aria-label='Send your selection to the automated assitant.' onClick={this.sendInput}>Send</button>
                    </div>
                </div>
            </div>
        );
    }
}